module.exports = __webpack_public_path__ + "static/img/ARCHERY.6ecbc6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/ARCHERY.jpg
// module id = Csx0
// module chunks = 2